var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPendingpayments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D83F87;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M346.4,242c-74.4,0-135,60.6-135,135s60.6,135,135,135s135-60.6,135-135S420.8,242,346.4,242z M366.4,381 c0,8.3-6.7,15-15,15H306c-8.3,0-15-6.7-15-15s6.7-15,15-15h30.4v-30.6c0-8.3,6.7-15,15-15s15,6.7,15,15V381z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M183.9,405.8c-2.8,0.5,1,0.2-78,0.3c-8.3,0-15-6.7-15-15s6.7-15,15-15c80.2,0,75.3,0,75.5,0 c0.1-10.2,1-20.2,2.9-29.9h-78.3c-8.3,0-15-6.7-15-15s6.7-15,15-15h87c24.5-61.6,84.6-104.4,153.9-104.2V59.5 c0-22.8,8.6-43.7,22.7-59.5H105C63.7,0,30,33.6,30,75v421.8c0,13.5,16.5,20.1,25.8,10.4l19.2-20l20.3,20.3c5.8,5.9,15.3,5.9,21.2,0 l19.2-19.2l19.4,19.2c5.9,5.8,15.3,5.8,21.1,0l19.7-19.5l19.7,19.5c5.8,5.8,15.3,5.8,21.1,0l3.8-3.8 C211.4,479.2,190.8,444.8,183.9,405.8L183.9,405.8z M154.2,180.9c4.5-6.9,13.8-8.9,20.8-4.3c7.5,4.9,19.9,6.7,26.1,3.8 c4.4-2,7.6-6.3,8.1-10.6c1-9-11.1-13.4-19.3-16.7c-10.4-4.1-23.3-9.2-30.7-22.5c-10.5-19-1.1-44.4,20.7-52.7v-2.2 c0-8.3,6.7-15,15-15c8.3,0,15,6.7,15,15V77c6.4,1.8,12.3,4.8,17,9.2c6.1,5.6,6.5,15.1,0.9,21.2s-15.1,6.5-21.2,0.8 c-3.4-3.2-13.2-4.4-17.7-1.3c-3.2,2.2-4.8,6.5-3.3,9.2c4.2,7.6,22.8,9.2,37.3,20.5c28.1,21.9,18,61.9-12.9,72.6v3.1 c0,8.3-6.7,15-15,15c-8.3,0-15-6.7-15-15v-1.9c-8-1.7-15.4-4.8-21.3-8.6C151.7,197.2,149.7,187.9,154.2,180.9z M106,256.1h75 c8.3,0,15,6.7,15,15s-6.7,15-15,15h-75c-8.3,0-15-6.7-15-15S97.7,256.1,106,256.1z M428.9,0c-29.3,0-53,23.7-53,53v158.2H467 c8.3,0,15-6.7,15-15V53C482,23.7,458.2,0,428.9,0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPendingpayments);
export default __webpack_public_path__ + "static/media/pending payments.a2a48c3c5813b56a4942305dd9087d4d.svg";
export { ForwardRef as ReactComponent };